<template>
  <div class="box6">
    <div class="box6-top-box">
      <div class="box6block" ref="block"></div>
      <pageTitle
        title="从零开始&nbsp;&nbsp;逐步成就高阶AI"
        text="覆盖AI职业完整技能，6个月助力学员高端就业"
      />

      <div class="info">
        <div class="tit">高级软件工程师课程</div>
        覆盖自然语言处理NLP、计算机视觉CV、数据科学推荐等AI各行业热门技术，培养AI专精型人才
      </div>

      <div class="subject-content">
        <div class="tag">市场价值(元)</div>
        <div class="arrow">
          <img src="../../../assets/coursePage/ai/box6/arrow.png" alt />
        </div>
        <div class="demo-box">
          <div class="demo" v-for="(item, index) in list" :key="index">
            <div class="num">{{ item.num }}k</div>
            <div class="title">{{ item.title }}</div>
            {{ item.text }}
          </div>
        </div>
      </div>
    </div>

    <div class="box6-btm-box">
      <pageTitle title="课程内容" text />
      <div class="box6-btm">
        <div
          class="subject-box"
          v-for="(item, index) in subject"
          :key="index"
          ref="item"
          :style="{
            backgroundColor:
              cur == index && showAnswer ? '#fff' : 'transparent',
          }"
        >
          <div class="subject" @click="changeCur(index)">
            <div class="title">
              <p>{{ item.stage }}</p>
              {{ item.title }}
            </div>
            <div
              class="icon"
              :class="{ 'img-rotate': cur == index && showAnswer }"
            >
              <img src="../../../assets/coursePage/ai/box6/icon-down.png" alt />
            </div>
          </div>

          <div
            class="course-content"
            :class="{ 'show-answer': cur == index && showAnswer }"
          >
            <div class="line"></div>
            <div class="title-icon">
              <img
                src="../../../assets/coursePage/ai/box6/icon1.png"
                alt
              />主要内容
            </div>
            <div class="main-content">
              <div class="block" v-for="i in item.content" :key="i">
                {{ i }}
              </div>
            </div>

            <div class="title-icon">
              <img
                src="../../../assets/coursePage/ai/box6/icon2.png"
                alt
              />可解决的现实问题
            </div>
            <div class="main-text">
              <p v-for="j in item.light" :key="j">{{ j }}</p>
            </div>

            <div class="title-icon">
              <img
                src="../../../assets/coursePage/ai/box6/icon3.png"
                alt
              />可掌握的核心能力
            </div>
            <div class="main-text main-text2">
              <p v-for="k in item.ability" :key="k">{{ k }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="btn" @click="openDetail">查看详细大纲</div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import check from "../../../utils/check";
export default {
  components: {
    pageTitle,
  },
  mounted() {},
  data() {
    return {
      list: [
        {
          title: "掌握计算机视觉基础算法，完成CV多场景项目",
          text: "阶段：CV计算机视觉处理基础与项目(403h)",
          num: "35",
        },
        {
          title: "掌握多场景NLP自然语言处理项目，进阶高阶人工智能开发",
          text: "阶段：人工智能NLP多场景项目（269h）",
          num: "32",
        },
        {
          title: "深度学习与NLP自然语言基础，使用Pytorch完成NLP模型搭建",
          text: "阶段：深度学习与NLP自然语言处理基础（211h）",
          num: "28",
        },
        {
          title: "掌握机器学习技术栈，完成数据挖掘项目",
          text: "阶段：机器学习与数据挖掘项目（157h）",
          num: "24",
        },
        {
          title: "掌握SQL及Pandas完成数据处理和可视化操作",
          text: "阶段：数据处理与统计分析（99h）",
          num: "20",
        },
        {
          title: "掌握AI开发必备的Python高级语法",
          text: "阶段：Python编程进阶（74h）",
          num: "14",
        },
        {
          title: "用主流AI编程语言完成基础程序编写",
          text: "阶段：Python编程基础（47h）",
          num: "10",
        },
      ],

      subject: [
        {
          stage: "阶段一",
          title: "Python编程基础",
          tag: "必学",
          content: [
            "Python基础语法",
            "Python数据处理",
            "函数",
            "文件读写",
            "异常处理",
            "模块和包",
          ],
          light: [
            "熟练掌握人工智能Python语言，建立编程思维以及面向对象程序设计思想，使学员能够熟练使用Python技术完成基础程序编写。",
          ],
          ability: [
            "掌握Python开发环境基本配置",
            "掌握运算符、表达式、流程控制语句、数组等的使用",
            "掌握字符串的基本操作",
            "初步建立面向对象的编程思维",
            "熟悉异常捕获的基本流程及使用方式",
            "掌握类和对象的基本使用方式",
          ],
        },
        {
          stage: "阶段二",
          title: "Python编程进阶",
          tag: "必学",
          content: [
            "面向对象",
            "网络编程",
            "多任务编程",
            "高级语法",
            "Python编程综合项目",
          ],
          light: ["熟练使用Python，掌握人工智能开发必备Python高级语法。"],
          ability: [
            "掌握网络编程技术，能够实现网络通讯",
            "知道通讯协议原理",
            "掌握开发中的多任务编程实现方式",
            "知道多进程多线程的原理",
          ],
        },
        {
          stage: "阶段三",
          title: "数据处理与统计分析",
          tag: "必学",
          content: [
            "Linux",
            "MySQL与SQL",
            "Numpy矩阵运算库 ",
            "Pandas数据清洗 ",
            "Pandas数据整理",
            "Pandas数据可视化",
            "Pandas数据分析项目",
          ],
          light: ["掌握SQL及Pandas完成数据分析与可视化操作。"],
          ability: [
            "掌握Linux常用命令，为数据开发后续学习打下的良好基础",
            "掌握MySQL数据库的使用",
            "掌握SQL语法",
            "掌握使用Python操作数据库",
            "掌握Pandas案例",
            "知道绘图库使用",
            "掌握Pandas数据ETL",
            "掌握Pandas数据分析项目流程",
          ],
        },
        {
          stage: "阶段四",
          title: "机器学习与多场景案例实战",
          tag: "必学",
          content: [
            "机器学习简介",
            "K近邻算法",
            "线性回归 ",
            "逻辑回归",
            "决策树",
            "聚类算法",
            "集成学习",
            "机器学习进阶算法",
            "用户画像案例",
            "电商运营数据建模分析案例",
          ],
          light: ["掌握机器学习概念，利用多场景案例强化机器学习建模。"],
          ability: [
            "掌握机器学习算法基本原理",
            "掌握使用机器学习模型训练的基本流程",
            "掌握Sklearn常用机器学习相关开源库的使用",
            "熟练使用机器学习相关算法进行预测分析",
            "掌握不同业务场景下的指标体系搭建",
            "熟练使用各种数据分析工具进行数据提取与数据展示",
            "熟练运用常用数据分析模型解决业务问题",
          ],
        },
        {
          stage: "阶段五",
          title: "数据挖掘综合项目",
          tag: "必学",
          content: [
            "金融风控项目业务背景介绍",
            "风控建模介绍",
            "机器学习评分卡",
            "金融风控特征工程",
            "不均衡学习和异常检测",
            // "推荐项目数据采集",
            // "推荐系统召回业务",
            // "推荐系统排序业务",
            // "基于多路召回的实时推荐",
            // "推荐系统平台调度",
            // "推荐系统性能评估"
          ],
          light: ["掌握金融风控项目。"],
          ability: [
            "掌握风控业务场景的常用指标",
            "掌握评分卡的建模流程",
            "掌握评分卡特征工程的常用套路",
            "熟练运用机器学习算法解决风控业务场景下的问题",
            "掌握多行业推荐业务",
            "掌握推荐业务建模流程",
            "掌握召回，排序基础算法",
            "熟练运用机器学习算法解决推荐业务问题",
          ],
        },
        {
          stage: "阶段六",
          title: "深度学习与NLP自然语言处理基础 ",
          tag: "必学",
          content: [
            "深度学习基础",
            "BP神经网络",
            "经典神经网络结构（CNN&RNN）",
            "深度学习多框架对比",
            "深度学习正则化和算法优化",
            "深度学习Pytorch框架",
            "NLP任务和开发流程",
            "文本预处理",
            "RNN及变体原理与实战",
            "Transformer原理与实战",
            "Attention机制原理与实战",
            "传统序列模型",
            "迁移学习实战",
          ],
          light: [
            "掌握深度学习基础及神经网络经典算法；",
            "掌握全球热门的PyTorch技术，完成自然语言处理基础算法，诸如RNN、LSTM、GRU等技术。",
          ],
          ability: [
            "Pytorch工具处理神经网络涉及的关键点",
            "掌握神经网络基础知识",
            "掌握反向传播原理",
            "了解深度学习正则化与算法优化",
            "掌握NLP领域前沿的技术解决方案",
            "了解NLP应用场景",
            "掌握NLP相关知识的原理和实现",
            "掌握传统序列模型的基本原理和使用",
            "掌握非序列模型解决文本问题的原理和方案",
            "能够使用Pytorch搭建神经网络",
            "构建基本的语言翻译系统模型",
            "构建基本的文本生成系统模型",
            "构建基本的文本分类器模型",
            "使用ID-CNN+CRF进行命名实体识别",
            "使用fasttext进行快速的文本分类",
            "胜任多数企业NLP工程师职位",
          ],
        },
        {
          stage: "阶段七",
          title: "NLP自然语言处理综合项目",
          tag: "赠送",
          content: [
            "解决方案列表",
            "项目架构及数据采集",
            "命名实体识别",
            "对话系统",
            "项目架构",
            "多模型预测",
            "模型的迭代优化",
            "模型的上线部署与总结",
            "智能文本分类",
            "模型上线",
          ],
          light: ["掌握在线医生项目。"],
          ability: [
            "医疗领域NER解决方案",
            "对话主题相关解决方案",
            "微信端服务部署解决方案",
            "对话管理系统与AI结合解决方案",
            "抽取式文本摘要解决方案",
            "生成式文本摘要解决方案",
            "自主训练词向量解决方案",
            "解码方案的优化解决方案",
            "数据增强优化解决方案",
            "大规模快速文本分类解决方案",
            "多模型并行预测解决方案",
            "分布式模型训练解决方案",
          ],
        },
        {
          stage: "阶段八",
          title: "CV基础&面试加强",
          tag: "赠送",
          content: [
            "机器学习核心算法加强",
            "深度学习核心算法加强",
            "数据结构与算法",
            "多行业项目扩展",
            "图像与视觉处理介绍",
            "目标分类和经典CV网络",
            "目标检测和经典CV网络",
            "目标分割和经典CV网络",
          ],
          light: [
            "掌握数据结构与算法，核心机器学习、深度学习面试题，助力高薪就业；",
            "掌握计算机视觉基础算法，诸如CNN、残差网络、Yolo及SSD。",
          ],
          ability: [
            "机器学习与深度学习核心算法，NLP经典算法，数据结构算法、Djkstra算法，动态规划初步，贪心算法原理，多行业人工智能案例剖析",

            "经典卷积网络：LeNet5、AlexNet、 VGG、 Inception、GoogleNlet、残差网络、深度学习优化；RCNN、FastRCNN；FasterRCNN；SSD、YOLOM、YOLOV5-7",
          ],
        },
        {
          stage: "阶段九",
          title: "CV计算机视觉综合项目",
          tag: "赠送",
          content: [
            "解决方案列表",
            "项目架构及数据采集",
            "人脸检测与跟踪",
            "人脸姿态任务",
            "人脸多任务",
            "系统集成",
          ],
          light: ["掌握人脸支付项目或智慧交通项目或实时人脸识别项目。"],
          ability: [
            "人脸检测与跟踪解决方案",
            "人脸姿态任务解决方案",
            "人脸多任务解决方案",
            "人脸识别任务解决方案",
            "系统集成解决方案",
          ],
        },
      ],
      cur: -1,
      showAnswer: true,
      prevItemHeight: 0,
    };
  },
  methods: {
    openDetail() {
      if (localStorage.getItem(`detail-${check.getUrlParam("nid")}`)) {
        window.location.href = localStorage.getItem(
          `detail-${check.getUrlParam("nid")}`
        );
      } else {
       this.clickZiXun()
      }
      this.mai("人工智能开发-AI就业课","查看详细大纲",0,null)
    },
    goTop(index) {
      window.scrollTo(
        0,
        this.$refs.item[index].offsetTop -
          this.$refs.block.offsetHeight -
          this.$refs.block.offsetHeight * 0.3 -
          this.prevItemHeight
      );
    },
    changeCur(index) {
      const a = document.querySelector(".show-answer");
      if (a != null && index > this.cur) {
        this.prevItemHeight = a.offsetHeight;
      }
      if (!this.showAnswer || index <= this.cur) {
        this.prevItemHeight = 0;
      }
      if (index == this.cur) {
        this.showAnswer = !this.showAnswer;
      } else {
        this.showAnswer = true;
        this.cur = index;
      }
      this.goTop(index);
    },
    toLink() {
      window.open("https://m.boxuegu.com/");
    },
  },
};
</script>

<style lang="less" scoped>
.box6 {
  .box6block {
    height: 80px;
  }
  .box6-top-box {
    width: 100%;
    background: url("../../../assets/coursePage/ai/box6/bg.png") no-repeat;
    background-size: cover;
  }

  .box6-btm-box {
    padding-bottom: 88px;
    width: 100%;
    background: linear-gradient(180deg, #f3fdff 0%, #eaf8fd 78%, #f7fdff 100%);
    .box6-btm {
      margin-top: 48px;
    }
  }

  .btn {
    margin: 0 auto;
    margin-top: 48px;
    width: 686px;
    height: 96px;
    background: linear-gradient(270deg, #1fd7cd 0%, #65adff 100%);
    box-shadow: 0px 4px 12px 0px rgba(64, 128, 255, 0.12);
    border-radius: 48px;
    text-align: center;
    font-size: 30px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: #ffffff;
    line-height: 96px;
  }

  .info {
    margin: 0 auto;
    margin-top: 28px;
    margin-bottom: 88px;
    padding: 0px 58px;
    padding-top: 48px;
    width: 726px;
    height: 232px;
    background: url("../../../assets/coursePage/ai/box6/info.png") no-repeat;
    background-size: cover;
    box-sizing: border-box;

    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #86909c;
    line-height: 40px;
    .tit {
      margin-bottom: 4px;
      font-size: 28px;
      text-align: center;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      color: #009ef8;
      line-height: 48px;
    }
  }
  .subject-content {
    position: relative;
    display: flex;
    justify-content: center;
    padding: 0px 32px;
    box-sizing: border-box;

    .tag {
      position: absolute;
      top: -56px;
      left: 32px;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #009ef8;
      line-height: 44px;
    }
    .arrow {
      margin-left: 72px;
      width: 18px;
      height: 1227px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .demo-box {
      margin-left: 26px;
      .demo {
        position: relative;
        margin-bottom: 32px;
        padding: 24px;
        padding-right: 0px;
        width: 572px;
        background: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0.8) 0%,
          rgba(255, 255, 255, 0.2) 100%
        );
        border-radius: 16px;
        box-sizing: border-box;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #86909c;
        line-height: 40px;

        &::after {
          position: absolute;
          top: 24px;
          left: -47px;
          content: "";
          min-width: 24px;
          max-width: 24px;
          height: 24px;
          background: #ffffff;
          border: 5px solid #15b6ff;
          border-radius: 50%;
          box-sizing: border-box;
        }
        .num {
          position: absolute;
          top: 24px;
          left: -114px;
          font-size: 28px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: #009ef8;
          line-height: 40px;
        }
        .title {
          margin-bottom: 12px;
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #009ef8;
          line-height: 40px;
        }
      }
    }
  }

  .subject-box {
    margin: 0 auto;
    margin-bottom: 16px;
    width: 686px;
    overflow: hidden;
    border-radius: 16px;
  }
  .subject {
    display: flex;
    align-items: center;
    position: relative;
    padding: 22px 0px 22px 35px;
    padding-right: 22px;
    width: 100%;
    height: 96px;
    background: #ffffff;
    border-radius: 16px;
    box-sizing: border-box;
    z-index: 5;
    justify-content: space-between;

    .title {
      margin-right: 20px;

      display: flex;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #020941;
      line-height: 40px;
      p {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 600;
        line-height: 40px;
        color: #009ef8;
        margin-right: 16px;
      }
    }

    .icon {
      width: 28px;
      height: 28px;
      transition: 0.5s ease all;
      margin-right: 5px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .img-rotate {
      transition: 0.5s ease all;
      transform: rotate(180deg);
    }

    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4e5969;
  }

  .course-content {
    padding: 0px 24px;
    position: relative;
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    max-height: 0;
    opacity: 0;
    transition: 0.3s ease all;
    overflow: hidden;
    z-index: 3;
    padding: 0px 40px 0px;
    .line {
      margin-bottom: 28px;
      width: 622px;
      height: 1px;
      background: #f2f3f5;
      margin-left: -8px;
    }
  }

  .show-answer {
    padding: 0px 40px 0px;
    border-radius: 16px;
    // display: block;
    max-height: 2400px;
    opacity: 1;
    transition: 0.4s ease all;
  }

  .title-icon {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    height: 44px;
    font-size: 28px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: #1d2129;
    img {
      margin-right: 14px;
      width: 32px;
      height: 32px;
    }
  }

  .main-content {
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap;
    margin-left: 45px;
    .block {
      background: rgba(106, 161, 255, 0.1);
      border-radius: 10px;
      margin-bottom: 16px;
      margin-right: 16px;
      padding: 8px 20px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 40px;
    }
  }

  .main-text,
  .main-text2 {
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #66666c;
    margin-bottom: 5px;
    margin-left: 45px;
    margin-bottom: 40px;
    line-height: 44px;
  }
  .main-text2 {
    p {
      position: relative;
      &::before {
        content: "";
        display: block;
        width: 4px;
        height: 4px;
        background: #86909c;
        position: absolute;
        left: -22px;
        top: 18px;
        border-radius: 50%;
      }
    }
  }
}
</style>
